import { Alert } from "antd";
import { continents, countries } from "countries-list";
import { useState, useEffect } from "react";
import Poll from "../../../models/clubadmin/Polls";
import { applicationError } from "../../../redux/actions/error";
import {
  fbCreateSuperAdminPoll,
  fbUpdateSuperAdminPoll,
  getPoll,
} from "../../../services/firebaseService/endPoints/poll";
import { FInput } from "../../commons/formFields/FInput";
import { FSelect } from "../../commons/formFields/FSelect";
import FUpload from "../../commons/formFields/FUpload";
import LoadingModal from "../../commons/LoadingModal";
import { withRouter } from "../../../utils/helper";
import fakeDispatch from "../../../utils/fakeDispatch";
import useGroupsData from "../group/useGroupsData";
import GroupSearch from "../../commons/GroupSearch";

let countryCodes = {};
Object.keys(countries).forEach((code) => {
  countryCodes[code] = countries[code].name;
});

const CreateSuperAdminPoll = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [editMode] = useState(!!props.router.params.id);
  const [groups, setGroups] = useState([]);
  const [count, setCount] = useState("0 groups");
  const [params, setParams] = useState([]);
  const [optionKeys, setOptionKeys] = useState(["op1", "op2"]);
  const [imageList, setImageList] = useState([]);
  const [allGroups, setAllGroups] = useState([]);
  const [errorInForm, setErrorInForm] = useState({
    isError: false,
    visible: false,
    message: "",
  });
  const [sponsorImage, setSponsorImage] = useState(undefined);
  const [imageFile, setImageFile] = useState(undefined);
  const [editConfigurations, setEditConfigurations] = useState({
    pollImageChanged: false,
    sponsorImageChanged: false,
  });
  const [sponsorImageList, setSponsorImageList] = useState([]);
  // Dynamic form fields: desc, days, hours, sponsorName, op1..op5, and any
  // additional fields spread from Poll.fromDataSet (options, isActive, etc.)
  const [formFields, setFormFields] = useState({});

  const handleAdd = () => {
    setOptionKeys((prev) => [...prev, `op${prev.length + 1}`]);
  };

  const handleInputChange = (e) => {
    setFormFields((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleOptionChange = (e) => {
    setFormFields((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleImageChange = ({ fileList }) => {
    let result = {};
    if (fileList.length === 0) {
      result.imageFile = {};
    } else {
      result.imageFile = fileList[0].originFileObj;
    }
    result.imageList = fileList;
    setImageFile(result.imageFile);
    setImageList(result.imageList);
    setEditConfigurations((prev) => ({ ...prev, pollImageChanged: true }));
  };

  const uploadAction = (file) => {
    setImageFile(file);
    setEditConfigurations((prev) => ({ ...prev, pollImageChanged: true }));
  };

  const handleSearchParamChange = (list) => {
    let resolvedParams = [];
    list.forEach((param) => {
      let changeParam = false;

      let group = allGroups.find((group) => group.groupName === param);
      if (group) {
        resolvedParams.push(group.id);
        changeParam = true;
      }
      let groupForLeague = allGroups.find((group) => group.leagueName === param);
      if (groupForLeague) {
        resolvedParams.push(groupForLeague.leagueId);
        changeParam = true;
      }
      let groupForClub = allGroups.find((group) => group.clubName === param);
      if (groupForClub) {
        resolvedParams.push(groupForClub.clubId);
        changeParam = true;
      }
      if (!changeParam) {
        resolvedParams.push(param);
      }
    });

    let groupCount =
      list.length > 0
        ? list.includes("global")
          ? allGroups.length
          : allGroups.filter(
              (group) =>
                resolvedParams.includes(group.id) ||
                resolvedParams.includes(group.leagueId) ||
                resolvedParams.includes(group.clubId) ||
                resolvedParams.includes(continents[group.supportersRegion]) ||
                resolvedParams.includes(countryCodes[group.supportersCountry])
            ).length
        : allGroups.length;

    setGroups(Array.from(new Set(resolvedParams)));
    setCount(`${groupCount} groups`);
  };

  const handleSponsorImageChange = ({ fileList }) => {
    let result = {};
    if (fileList.length === 0) {
      result.sponsorImageList = [];
    } else {
      result.sponsorImage = fileList[0].originFileObj;
    }
    result.sponsorImageList = fileList;

    if (result.sponsorImage !== undefined) {
      setSponsorImage(result.sponsorImage);
    }
    setSponsorImageList(result.sponsorImageList);
    setEditConfigurations((prev) => ({ ...prev, sponsorImageChanged: true }));
  };

  const sponsorUploadAction = (file) => {
    setSponsorImage(file);
    setEditConfigurations((prev) => ({ ...prev, sponsorImageChanged: true }));
  };

  const handleErrorMessageClose = () => {
    setErrorInForm((prev) => ({ ...prev, visible: false }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    let data = new Poll();
    data.toDataset({
      ...formFields,
      groups,
      optionKeys,
      imageFile,
      sponsorImage,
      editConfigurations,
      createdByDocId: "superadmin",
      createdByDocName: "superadmin",
    });

    if (data.hasError) {
      window.scrollTo(0, 0);
      setErrorInForm({
        isError: true,
        visible: true,
        message: data.hasError.message,
      });
      setIsLoading(false);
      window.scrollTo(0, 0);
      setTimeout(handleErrorMessageClose, 5000);
    } else {
      let promise;
      if (!editMode) {
        promise = fbCreateSuperAdminPoll(data, imageFile, sponsorImage);
      } else {
        promise = fbUpdateSuperAdminPoll(
          data,
          editConfigurations.pollImageChanged ? imageFile : undefined,
          editConfigurations.sponsorImageChanged ? sponsorImage : undefined,
          props.router.params.id
        );
      }

      promise
        .then(() => {
          props.router.navigate("/superadmin/polls/");
        })
        .catch((err) => {
          window.scrollTo(0, 0);
          setErrorInForm({
            isError: true,
            visible: true,
            message: err.message,
          });
          setIsLoading(false);
          window.scrollTo(0, 0);
          setTimeout(handleErrorMessageClose, 5000);
        });
    }
  };

  const handleEditMode = (currentAllGroups) => {
    getPoll(props.router.params.id).then((doc) => {
      if (!doc) {
        props.dispatch(
          applicationError({
            err: {},
            errorCode: "404",
          })
        );
        return;
      }

      let data = new Poll();
      data.fromDataSet(doc);

      let groupCount = data.groups.includes("global")
        ? currentAllGroups.length
        : currentAllGroups.filter(
            (group) =>
              data.groups.includes(group.id) ||
              data.groups.includes(group.leagueId) ||
              data.groups.includes(group.clubId) ||
              data.groups.includes(continents[group.supportersRegion]) ||
              data.groups.includes(countryCodes[group.supportersCountry])
          ).length;

      let resolvedParams = [];
      data.groups.forEach((param) => {
        let paramsChanged = false;
        let group = currentAllGroups.find((group) => group.id === param);
        if (group) {
          resolvedParams.push(group.groupName);
          paramsChanged = true;
        }
        let groupForLeague = currentAllGroups.find(
          (group) => group.leagueId === param
        );
        if (groupForLeague) {
          resolvedParams.push(group.leagueName); // preserving original: uses `group` not `groupForLeague`
          paramsChanged = true;
        }
        let groupForClub = currentAllGroups.find(
          (group) => group.clubId === param
        );
        if (groupForClub) {
          resolvedParams.push(groupForClub.clubName);
          paramsChanged = true;
        }
        if (!paramsChanged) {
          resolvedParams.push(param);
        }
      });
      resolvedParams = Array.from(new Set(resolvedParams));

      // Apply structured state from Poll model
      setEditConfigurations(
        data.editConfigurations || { pollImageChanged: false, sponsorImageChanged: false }
      );
      setImageList(data.imageList || []);
      setSponsorImageList(data.sponsorImageList || []);
      setImageFile(data.imageFile);
      setGroups(data.groups || []);
      setOptionKeys(data.optionKeys || ["op1", "op2"]);

      // Apply form fields from Poll model
      const opFields = (data.optionKeys || []).reduce(
        (acc, key) => ({ ...acc, [key]: data[key] }),
        {}
      );
      setFormFields((prev) => ({
        ...prev,
        desc: data.desc,
        sponsorName: data.sponsorName,
        days: data.days,
        hours: data.hours,
        options: data.options,
        isActive: data.isActive,
        isCancelled: data.isCancelled,
        noOfPolls: data.noOfPolls,
        addedOn: data.addedOn,
        postedOn: data.postedOn,
        closesOn: data.closesOn,
        createdByDocId: data.createdByDocId,
        createdByName: data.createdByName,
        ...opFields,
      }));

      setIsLoading(false);
      setCount(`${groupCount} groups`);
      setParams(resolvedParams);
    });
  };

  // componentDidMount
  useEffect(() => {
    const groupsProp = props.groups;
    if (props.router.params.id) {
      setAllGroups(groupsProp);
      setCount(`${groupsProp.length} groups`);
      handleEditMode(groupsProp);
    } else {
      setAllGroups(groupsProp);
      setCount(`${groupsProp.length} groups`);
      setIsLoading(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // componentDidUpdate: sync allGroups when props.groups changes
  useEffect(() => {
    if (props.groups) {
      setAllGroups(props.groups);
    }
  }, [props.groups]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleGroupSelectionChange = (groupIds) => {
    setGroups(groupIds);
  };

  let duration = {
    hours: Array.from({ length: 24 }, (_, k) => k),
    days: Array.from({ length: 10 }, (_, k) => k),
  };

  return (
    <>
      <LoadingModal loading={isLoading} />
      {errorInForm.isError && errorInForm.visible && (
        <div className="mx-5 mt-2">
          <Alert
            message="Error"
            description={errorInForm.message}
            type="error"
            closable
            afterClose={handleErrorMessageClose}
          />
        </div>
      )}
      <div className="mx-md-5 p-2 border-box">
        <h6>Poll</h6>
        <form
          onSubmit={handleSubmit}
          className="border rounded p-3 px-3"
          style={{ backgroundColor: "white" }}
        >
          <div
            style={{
              // margin: "-5px 15px",
              marginBottom: "24px",
            }}
          >
            <GroupSearch
              label="Select Groups"
              allGroups={allGroups}
              onSelectedGroupIdsChange={handleGroupSelectionChange}
            />
          </div>
          <div className="col-md-6">
            <div className="border rounded p-3 px-3">
              <FInput
                label="Poll Question"
                name="desc"
                display="col"
                placeholder="Enter your question here..."
                onChange={handleInputChange}
                value={formFields.desc}
                required
              />
              <FUpload
                label="Image(Optional)"
                action={uploadAction}
                fileList={imageList}
                onChange={handleImageChange}
                display="col"
                membershipCard={true}
                aspectRatio={16 / 9}
              />
              <div>
                <div
                  className="border rounded p-3 px-3"
                  style={{ backgroundColor: "rgba(0,0,0,0.02)" }}
                >
                  <h6>Answers</h6>
                  {optionKeys.map((key, index) => (
                    <FInput
                      key={index}
                      label=""
                      name={key}
                      display="col"
                      placeholder={`Answer #${index + 1}`}
                      onChange={handleInputChange}
                      value={formFields[key]}
                    />
                  ))}

                  <div>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-info mt-3 mb-2"
                      onClick={handleAdd}
                      disabled={optionKeys.length >= 5}
                    >
                      +Add New
                    </button>
                  </div>
                </div>
              </div>
              <div style={{ padding: "0px 15px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: 24,
                    marginBottom: "1rem",
                  }}
                >
                  Poll Length:
                </div>
                <div
                  className="col-md-4"
                  style={{
                    display: "flex",
                    gap: "8px",
                  }}
                >
                  <div>Days</div>
                  <div>
                    <FSelect
                      label=""
                      value={formFields.days}
                      onChange={handleOptionChange}
                      name="days"
                      dataList={duration.days}
                      dataOnlyValue
                      placeholder="Days"
                      display="col"
                      tabIndex="1"
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                    />
                  </div>
                </div>
                <div
                  className="col-md-4"
                  style={{
                    display: "flex",
                    gap: "8px",
                  }}
                >
                  <div>Hours</div>
                  <FSelect
                    label=""
                    value={formFields.hours}
                    onChange={handleOptionChange}
                    name="hours"
                    dataList={duration.hours}
                    dataOnlyValue
                    placeholder="Hours"
                    display="col"
                    tabIndex="1"
                    style={{
                      width: "100%",
                      borderRadius: "5px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div style={{ marginTop: 15 }}>
              <FUpload
                label="SponsorImage"
                action={sponsorUploadAction}
                fileList={sponsorImageList}
                onChange={handleSponsorImageChange}
                display="col"
                membershipCard={true}
                aspectRatio={16 / 9}
              />
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                Sponsor Name (optional)
              </div>
              <FInput
                label=""
                name="sponsorName"
                display="col"
                placeholder="For Internal Reference Only"
                onChange={handleInputChange}
                value={formFields.sponsorName}
              />
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <button className="btn btn-success" tabIndex="14" type="success">
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

// Create a wrapper functional component
const CreateSuperAdminPollWithGroups = (props) => {
  const { groups, isLoading } = useGroupsData();

  return (
    <CreateSuperAdminPoll
      {...props}
      dispatch={fakeDispatch}
      groups={groups}
      groupsLoading={isLoading}
    />
  );
};

export default withRouter(CreateSuperAdminPollWithGroups);
